import { Flex, Text } from "@chakra-ui/react"
import { Link } from "react-router-dom"

const DashboardCard = ({icon, title, to}) => {
    return (
        <Flex
            w={{base: '100%', md: '100%'}}
            h={{ base: '130px', md: '200px' }}
            bg='white'
            mb='25px'
            borderRadius='8px'
            shadow='md'
            _hover={{
                cursor: 'pointer',
                transform: 'scale(1.02)',
                transition: 'all 0.2s ease-in-out'
            }}
            justifyContent="center"
            alignItems="center"
        >
            <Link
                to={to}
                style={{
                    textDecoration: 'none',
                    color: 'black',
                    display: 'flex',  
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%'
                }}
            >
                {icon}
                <Text ml='1em'>{title}</Text>
            </Link>
        </Flex>
    )
}

export default DashboardCard